var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Helper } from '../../main';
import { Request } from '..';
import { HttpExclude } from '../../decorators';
/**
 * Usage for processing of sending/receiving data and render data.
 */
var Model = /** @class */ (function () {
    function Model() {
        /**
         * Associates instances of Schema into a model.
         * ```typescript
         * import {Model, SchemaSet} from 'simpli-web-sdk'
         * import {InputUserSchema} from '@/schema/User/InputUserSchema'
         * import {ListUserSchema} from '@/schema/User/ListUserSchema'
         * import {CsvUserSchema} from '@/schema/User/CsvUserSchema'
         *
         * export class User extends Model {
         *   readonly $schemaSet: SchemaSet = {
         *     input: new InputUserSchema(),
         *     list: new ListUserSchema(),
         *     csv: new CsvUserSchema(),
         *   }
         *
         *   email: string | null = null
         *   name: string | null = null
         * }
         * ```
         */
        this.$schemaSet = {};
    }
    /**
     * Calls HTTP GET request, and defines the response as an array of this model.
     * Note: the default spinner name of the [[Await]] component is 'list'.
     *
     * ```typescript
     * import {Model} from 'simpli-web-sdk'
     * import {User} from '@/model/User'
     *
     * async function example() {
     *   const resp = await new User().$listFrom('/user')
     *   const users: User[] = resp.data
     * }
     * ```
     *
     * @param url The absolute or endpoint URL
     */
    Model.prototype.$listFrom = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Request.get(url)
                            .name(this.$getSpinnerName('list'))
                            .asArrayOf(this.$clone())
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Calls HTTP GET request, and defines the response as this model.
     * Note: the default spinner name of the [[Await]] component is 'populate'.
     *
     * ```typescript
     * import {Model} from 'simpli-web-sdk'
     * import {User} from '@/model/User'
     *
     * async function example() {
     *   const user = new User()
     *   await user.$populateFrom('/user/1')
     *   // the user will be populated
     * }
     * ```
     *
     * @param url The absolute or endpoint URL
     */
    Model.prototype.$populateFrom = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Request.get(url)
                            .name(this.$getSpinnerName('populate'))
                            .as(this)
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Calls HTTP POST request, and defines the response as any type.
     * Note: the default spinner name of the [[Await]] component is 'persist'.
     *
     * ```typescript
     * import {Model} from 'simpli-web-sdk'
     * import {User} from '@/model/User'
     *
     * async function example() {
     *   const user = new User()
     *   user.name = 'Michael Jackson'
     *
     *   await user.$persistFrom('/user')
     *   // the changes will be persisted
     * }
     * ```
     *
     * @param url The absolute or endpoint URL
     */
    Model.prototype.$persistFrom = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Request.post(url, this)
                            .name(this.$getSpinnerName('persist'))
                            .asAny()
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Calls HTTP PUT request, and defines the response as any type.
     * Note: the default spinner name of the [[Await]] component is 'update'.
     *
     * ```typescript
     * import {Model} from 'simpli-web-sdk'
     * import {User} from '@/model/User'
     *
     * async function example() {
     *   const user = new User()
     *   await user.$populateFrom('/user/1')
     *
     *   user.name = 'Michael Jackson'
     *
     *   await user.$updateFrom('/user/1')
     *   // the changes will be persisted
     * }
     * ```
     *
     * @param url The absolute or endpoint URL
     */
    Model.prototype.$updateFrom = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Request.put(url, this)
                            .name(this.$getSpinnerName('update'))
                            .asAny()
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Calls HTTP DELETE request, and defines the response as any type.
     * Note: the default spinner name of the [[Await]] component is 'remove'.
     *
     * ```typescript
     * import {Model} from 'simpli-web-sdk'
     * import {User} from '@/model/User'
     *
     * async function example() {
     *   const user = new User()
     *   await user.$removeFrom('/user/1')
     *   // remove this user from database
     * }
     * ```
     *
     * @param url The absolute or endpoint URL
     */
    Model.prototype.$removeFrom = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Request.delete(url)
                            .name(this.$getSpinnerName('remove'))
                            .asAny()
                            .getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Customizes the spinner name.
     * This methods should be overwrited in order to take its effect.
     *
     * ```typescript
     * import {Model} from 'simpli-web-sdk'
     *
     * export class User extends Model {
     *   $getSpinnerName(command: string) {
     *     return `user_${command}`
     *   }
     *
     *   email: string | null = null
     *   name: string | null = null
     * }
     *
     * await function example() {
     *   const user = new User()
     *   await user.$populateFrom('/user/1')
     *   // the spinner name is 'user_populate'
     * }
     * ```
     *
     * @param command The default spinner name of the [[Await]] component from methods
     * $listFrom, $populateFrom, $persistFrom, $updateFrom and $removeFrom
     */
    Model.prototype.$getSpinnerName = function (command) {
        return "" + command;
    };
    /**
     * Gets a model's schema instance by its reference name.
     * Returns null if it is not found.
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$getSchema('input')
     * }
     *
     * @param schemaRef The schema reference name
     * ```
     */
    Model.prototype.$getSchema = function (schemaRef) {
        return this.$schemaSet[schemaRef] || null;
    };
    /**
     * Gets the name of a model's schema by its reference name.
     * Returns null if it is not found.
     *
     * Alias of `this.$getSchema(schemaRef).name`
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$getSchemaName('input')
     * }
     *
     * @param schemaRef The schema reference name
     */
    Model.prototype.$getSchemaName = function (schemaRef) {
        var schema = this.$getSchema(schemaRef);
        return schema ? schema.name : null;
    };
    /**
     * Gets all fields from a model's schema by its reference name.
     * Returns empty array ([]) if it is not found.
     *
     * Alias of `this.$getSchema(schemaRef).allFields`
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$allFieldsFrom('input')
     * }
     *
     * @param schemaRef The schema reference name
     */
    Model.prototype.$allFieldsFrom = function (schemaRef) {
        var schema = this.$getSchema(schemaRef);
        return schema ? schema.allFields : [];
    };
    /**
     * Gets all headers from a model's schema by its reference name.
     * Returns empty array ([]) if it is not found.
     *
     * Alias of `this.$getSchema(schemaRef).allHeaders`
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$allHeadersFrom('input')
     * }
     *
     * @param schemaRef The schema reference name
     */
    Model.prototype.$allHeadersFrom = function (schemaRef) {
        var schema = this.$getSchema(schemaRef);
        return schema ? schema.allHeaders : [];
    };
    /**
     * Gets the header as [[Dictionary]] from a model's schema by its reference name.
     * Returns empty object ({}) if it is not found.
     *
     * Alias of `this.$getSchema(schemaRef).header`
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$headerFrom('input')
     * }
     *
     * @param schemaRef The schema reference name
     */
    Model.prototype.$headerFrom = function (schemaRef) {
        var schema = this.$getSchema(schemaRef);
        return schema ? schema.header : {};
    };
    /**
     * Gets the data as [[Dictionary]] from a model's schema by its reference name.
     * Returns empty object ({}) if it is not found.
     *
     * Alias of `this.$getSchema(schemaRef).getModelData(this)`
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$dataFrom('input')
     * }
     *
     * @param schemaRef The schema reference name
     */
    Model.prototype.$dataFrom = function (schemaRef) {
        var schema = this.$getSchema(schemaRef);
        return schema ? schema.getModelData(this) : {};
    };
    /**
     * Translates a field from a model's schema by its reference name.
     * Returns empty string ('') if it is not found.
     *
     * Alias of `this.$getSchema(schemaRef).translateFrom(fieldName)`
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$translateFrom('input', 'email')
     * }
     *
     * @param schemaRef The schema reference name
     * @param fieldName The schema's field name
     */
    Model.prototype.$translateFrom = function (schemaRef, fieldName) {
        var schema = this.$getSchema(schemaRef);
        return schema ? schema.translateFrom(fieldName) : '';
    };
    /**
     * Validates a model's schema by its reference name.
     * If there are errors, then throw an exception.
     *
     * Alias of `this.$getSchema(schemaRef).validate(this, showErrorMessage)`
     *
     * ```typescript
     * import {Model, SchemaSet} from 'simpli-web-sdk'
     * import {InputUserSchema} from '@/schema/User/InputUserSchema'
     *
     * export class User extends Model {
     *   readonly $schemaSet: SchemaSet = {
     *     input: new InputUserSchema(),
     *   }
     * }
     *
     * function example() {
     *   const user = new User()
     *   user.$validate('input')
     * }
     *
     * @param schemaRef The schema reference name
     * @param showErrorMessage If true, then spans the first error message to the user
     */
    Model.prototype.$validate = function (schemaRef, showErrorMessage) {
        if (schemaRef === void 0) { schemaRef = 'input'; }
        if (showErrorMessage === void 0) { showErrorMessage = true; }
        var schema = this.$getSchema(schemaRef);
        schema && schema.validate(this, showErrorMessage);
    };
    /**
     * Clones this model and return its clone.
     *
     * Alias of `Helper.clone(this)`
     *
     * ```typescript
     * import {User} from '@/model/User'
     *
     * function example() {
     *   const user = new User()
     *   const clonedUser = user.$clone() // a copy of user instance
     * }
     */
    Model.prototype.$clone = function (options) {
        return Helper.clone(this, options);
    };
    __decorate([
        HttpExclude(),
        __metadata("design:type", Object)
    ], Model.prototype, "$schemaSet", void 0);
    return Model;
}());
export { Model };
//# sourceMappingURL=Model.js.map